'use strict';

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.array.some");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _isNan = require('babel-runtime/core-js/number/is-nan');

var _isNan2 = _interopRequireDefault(_isNan);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _RequestLimitExceeded = require('./errors/RequestLimitExceeded');

var _RequestLimitExceeded2 = _interopRequireDefault(_RequestLimitExceeded);

var _UnexpectedServerResponse = require('./errors/UnexpectedServerResponse');

var _UnexpectedServerResponse2 = _interopRequireDefault(_UnexpectedServerResponse);

var _urlParse = require('url-parse');

var _urlParse2 = _interopRequireDefault(_urlParse);

var _aws = require('aws41');

var _aws2 = _interopRequireDefault(_aws);

var _crypto = require('crypto');

var _crypto2 = _interopRequireDefault(_crypto);

var _BadRequestError = require('./errors/BadRequestError');

var _BadRequestError2 = _interopRequireDefault(_BadRequestError);

var _UnrectifiableClockSkewError = require('./errors/UnrectifiableClockSkewError');

var _UnrectifiableClockSkewError2 = _interopRequireDefault(_UnrectifiableClockSkewError);

var _formatAmazonDate = require('./formatAmazonDate');

var _formatAmazonDate2 = _interopRequireDefault(_formatAmazonDate);

var _isValidFunction = require('./utils/isValidFunction');

var _isValidFunction2 = _interopRequireDefault(_isValidFunction);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Handles request making retry and error notification
 * @param {fetch} fetch client
 * @param {Object} options configurable params
 * @param {number} options.retries number of retries to make on service / network error (optional, default: 3)
 * @param {number} options.delayInSecs delay to make in between retries (optional, default: 2)
 * @param {Object} options.credentials identifiers and secrets required to hit protected endpoints (optional, default: {})
 * @param {string} options.region specifies the region of the service
 * @param {string} options.correlationId specifies the correlationId to use in the request (optional)
 * @param {boolean} options.traceLogging sets trace logging on/off (optional, default: false)
 * @param {Function} options.getUserRegion optional function to return a user's region
 * @param {Function} options.getUserLanguage optional function to return a user's language
 */


var RequestMaker = function () {
  function RequestMaker(fetch) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck3["default"])(this, RequestMaker);
    this.fetch = fetch.bind();
    this.options = options;
    this.credentials = options.credentials || {};
    this.region = options.region;
    this.correlationId = options.correlationId;
    this.traceLogging = options.traceLogging || false;
    this.signal = options.signal || undefined;
    this.getUserRegion = options.getUserRegion;
    this.getUserLanguage = options.getUserLanguage;
    this.retries = options.retries === undefined || options.retries === null || (0, _isNan2["default"])(options.retries) ? 3 : options.retries;

    if (options.delayInSecs === null || options.delayInSecs === undefined) {
      this.delay = 2000;
    } else {
      this.delay = options.delayInSecs * 1000;
    }

    this.clockskew = 0;
  }

  (0, _createClass3["default"])(RequestMaker, [{
    key: 'setClockSkewFromAmazonResponse',
    value: function setClockSkewFromAmazonResponse(response) {
      var serverDate = new Date(response.headers.get('date'));

      if (isNaN(serverDate)) {
        throw new _UnrectifiableClockSkewError2["default"]('Server returned non-parsable date');
      }

      this.clockskew = serverDate - new Date();
    }
  }, {
    key: 'generateClockSkewAdjustedAmazonDate',
    value: function generateClockSkewAdjustedAmazonDate() {
      return (0, _formatAmazonDate2["default"])(new Date().getTime() + this.clockskew);
    }
    /**
     * Retries the failed request
     * @private
     * @param {string} method the HTTP method to make the request with
     * @param {string} url to send request to
     * @param {Object} options fetch options
     * @param {Array.<Number>} expectedResponse the expected response codes from server
     * @param {Number} count indicates the number of attempts
     * @param {Error} fetchError the error thrown by the fetch call that triggered this retry (optional)
     * @param {HTTPResponse} response response returned from the request (optional)
     * @returns {Promise}
     */

  }, {
    key: 'retryRequest',
    value: function retryRequest(method, url, options, expectedResponse, count, fetchError, response, delay) {
      var _this = this;

      if (count >= this.retries) {
        throw new _RequestLimitExceeded2["default"](method, url, fetchError, response ? response.text : null, response ? response.status : null, options.headers.correlationId);
      }

      return new _promise2["default"](function (resolve) {
        setTimeout(function () {
          resolve(_this.makeRequest(url, options, expectedResponse, count + 1, delay * 2));
        }, delay);
      });
    }
    /**
     * Generates the signing properties for AWS
     * @param {string} url of the request
     * @param {Object} options
     * @param {string} options.method method of the request
     * @param {Object} options.body body of request
     * @param {Object} options.headers headers to be sent in request
     * @param {Object} credentials to send within request
     */

  }, {
    key: 'generateSignedProperties',
    value: function generateSignedProperties(url, options, credentials) {
      var parsedUrl = new _urlParse2["default"](url);
      var requestOptions = {
        service: 'execute-api',
        host: parsedUrl.host,
        region: this.region,
        method: options.method,
        path: parsedUrl.pathname || '/',
        headers: options.headers,
        body: options.body
      };

      if (parsedUrl.query) {
        requestOptions.path += parsedUrl.query;
      }

      var signedProperties = _aws2["default"].sign(requestOptions, credentials);

      return signedProperties.headers;
    }
  }, {
    key: 'getRegionHeader',
    value: function getRegionHeader(options) {
      if (options.noRegion) {
        return undefined;
      }

      if (options.region) {
        return options.region;
      } else if ((0, _isValidFunction2["default"])(this.getUserRegion)) {
        return this.getUserRegion();
      }

      return undefined;
    }
  }, {
    key: 'getLanguageHeader',
    value: function getLanguageHeader(options) {
      if (options.noLanguage) {
        return undefined;
      }

      if (options.language) {
        return options.language;
      } else if ((0, _isValidFunction2["default"])(this.getUserLanguage)) {
        return this.getUserLanguage();
      }

      return undefined;
    }
    /**
     * Performs the network call for required resource
     * @param {string} url the fetch url to be forwarded to the fetch client
     * @param {Object} options the fetch options to be forwarded to the fetch client
     * @param {string} options.region override the region header in the request
     * @param {string} options.language override the language header in the request
     * @param {boolean} options.noRegion override to send no region header in the request
     * @param {boolean} options.noLanguage override to send no language header in the request
     * @param {Array.<number>} expectedResponse if the response is not included in this array the method will throw
     * @param {number} count an internal property to handle retry counting
     * @throws {RequestLimitExceeded} when the number of retries has exceeded
     * @throws {UnexpectedServerResponse} when the server returns a response not defined in expectedResponse
     * @throws {BadRequestError} when the server returns 400 Bad Request
     * @returns {Promise.<Response>}
     */

  }, {
    key: 'makeRequest',
    value: function () {
      var _ref = (0, _asyncToGenerator3["default"])( /*#__PURE__*/_regenerator2["default"].mark(function _callee(url) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var expectedResponse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [200];
        var count = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        var delay = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.delay;
        var method, regionHeader, languageHeader, signedHeaders, serverResponse, response, body, status;
        return _regenerator2["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                method = options.method || 'GET';
                options.headers = (0, _assign2["default"])({
                  correlationId: this.correlationId || this.generateCorrelationId(),
                  'Content-Type': 'application/json'
                }, options.headers || {});
                options.headers['X-Amz-Date'] = this.generateClockSkewAdjustedAmazonDate();

                if (this.signal) {
                  options.signal = this.signal;
                }

                regionHeader = this.getRegionHeader(options);
                languageHeader = this.getLanguageHeader(options);

                if (regionHeader) {
                  options.headers = (0, _extends3["default"])({}, options.headers, {
                    'user-region': this.getRegionHeader(options)
                  });
                }

                if (languageHeader) {
                  options.headers = (0, _extends3["default"])({}, options.headers, {
                    'user-language': this.getLanguageHeader(options)
                  });
                }

                if (this.credentials.accessToken) {
                  options.headers = (0, _assign2["default"])({
                    'access-key': this.credentials.accessToken
                  }, options.headers);
                }

                if (this.credentials.accessKeyId && this.credentials.secretAccessKey) {
                  signedHeaders = this.generateSignedProperties(url, options, this.credentials);
                  options.headers = (0, _extends3["default"])({}, options.headers, signedHeaders);
                }

                serverResponse = void 0;
                response = {};
                _context.prev = 12;

                if (this.traceLogging) {
                  body = undefined;

                  if (options && options.body) {
                    body = options.body;
                  }

                  this.logRequest(method, url, body);
                }

                _context.next = 16;
                return this.fetch(url, options);

              case 16:
                serverResponse = _context.sent;
                response.status = serverResponse.status;
                _context.next = 20;
                return serverResponse.text();

              case 20:
                response.text = _context.sent;
                response.headers = serverResponse.headers;

                if (response.text && ['Content-Type', 'content-type'].some(function (header) {
                  return serverResponse.headers.get(header) && serverResponse.headers.get(header).includes('application/json');
                })) {
                  response.json = JSON.parse(response.text);
                }

                if (this.traceLogging) {
                  this.logResponse(method, url, response.text);
                }

                _context.next = 31;
                break;

              case 26:
                _context.prev = 26;
                _context.t0 = _context['catch'](12);

                if (!(this.retries === 0)) {
                  _context.next = 30;
                  break;
                }

                throw _context.t0;

              case 30:
                return _context.abrupt('return', this.retryRequest(method, url, options, expectedResponse, count, _context.t0, null, delay));

              case 31:
                status = response.status;

                if (!(status === 429 || status >= 500 && status <= 599)) {
                  _context.next = 34;
                  break;
                }

                return _context.abrupt('return', this.retryRequest(method, url, options, expectedResponse, count, null, response, delay));

              case 34:
                if (!RequestMaker._isAmazonClockSkewError(response)) {
                  _context.next = 37;
                  break;
                }

                this.setClockSkewFromAmazonResponse(response);
                return _context.abrupt('return', this.retryRequest(method, url, options, expectedResponse, count, null, response, delay));

              case 37:
                if (expectedResponse.includes(status)) {
                  _context.next = 41;
                  break;
                }

                if (!(status === 400)) {
                  _context.next = 40;
                  break;
                }

                throw new _BadRequestError2["default"](method, url, status, options.headers.correlationId);

              case 40:
                throw new _UnexpectedServerResponse2["default"](method, url, status, options.headers.correlationId);

              case 41:
                return _context.abrupt('return', response);

              case 42:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[12, 26]]);
      }));

      function makeRequest(_x6) {
        return _ref.apply(this, arguments);
      }

      return makeRequest;
    }()
  }, {
    key: 'logRequest',
    value: function logRequest(method, url, body) {
      this.log('Request', method, url, body);
    }
  }, {
    key: 'logResponse',
    value: function logResponse(method, url, body) {
      this.log('Response', method, url, body);
    }
  }, {
    key: 'log',
    value: function log(type, method, url, body) {
      var bodyToLog = undefined;

      if (body) {
        bodyToLog = body.substring(0, 500);
      }

      console.log(type + ': ' + method + ' ' + url + ' ' + (bodyToLog ? '- body: ' + bodyToLog : ''));
    }
    /**
     * Generates a correlationId to send in the request
     * @private
     * @returns {string} correlationId
     */

  }, {
    key: 'generateCorrelationId',
    value: function generateCorrelationId() {
      return new Date().getTime() + '::' + _crypto2["default"].randomBytes(16).toString('hex');
    }
  }], [{
    key: '_isAmazonClockSkewError',
    value: function _isAmazonClockSkewError(response) {
      return response && response.headers && ['RequestTimeTooSkewed', 'RequestExpired', 'InvalidSignatureException', 'SignatureDoesNotMatch', 'AuthFailure', 'RequestInTheFuture'].includes(response.headers.get('x-amzn-errortype'));
    }
  }]);
  return RequestMaker;
}();

exports["default"] = RequestMaker;